import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';

function AssignModModal({ user, onClose }) {
  const { getAccessTokenSilently } = useAuth0();
  const [mods, setMods] = useState([]);
  const [selectedModId, setSelectedModId] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMods = async () => {
      try {
        const token = await getAccessTokenSilently();
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mods`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMods(res.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Failed to fetch mods:", error);
        setIsLoading(false);
      }
    };
    fetchMods();
  }, [getAccessTokenSilently]);

  const assignMod = async () => {
    try {
      const token = await getAccessTokenSilently();
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/${user.id}/mods/${selectedModId}`,
        {}, // No body needed
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert('Mod assigned to user!');
      onClose();
    } catch (error) {
      console.error("Failed to assign mod:", error);
      alert("Failed to assign mod. See console for details.");
    }
  };

  if (isLoading) return <div>Loading...</div>;

  return (
    <div className="modal">
      <h3 className="text-lg font-bold mb-2">Assign Mod to {user.email}</h3>
      <select
        className="border p-2 mb-4 w-full"
        value={selectedModId}
        onChange={(e) => setSelectedModId(e.target.value)}
      >
        <option value="">Select a mod</option>
        {mods.map((mod) => (
          <option key={mod.id} value={mod.id}>
            {mod.modName}
          </option>
        ))}
      </select>
      <br/>
      <div className="flex gap-2">
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
          onClick={assignMod}
          disabled={!selectedModId}
        >
          Assign
        </button>
        <button className="bg-gray-300 px-4 py-2 rounded" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default AssignModModal;
